import React from "react";

const SlideMainTitle = ({ text }) => {
  return (
    <h1 className="font-bold leading-[1] text-2xl md:text-3xl lg:text-5xl pb-4 dark:text-[#DCFCF3] text-center">
      {text}
    </h1>
  );
};

export default SlideMainTitle;
